





























































import { Component, Vue } from "vue-property-decorator";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import SelectOption from "@/components/common/SelectOption";
import { BalanceEffect, TransactionType } from "@/constants/PaymentConstants";
import TaxObligationLedgerPayload from "@/dto/tax/TaxObligationLedgerPayload";
import TaxObligationService from "@/services/TaxObligationService";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";
import moment from "moment";

@Component({
  components: {
    PortalInput,
    PortalSelect
  }
})
export default class AddLedgerRecordModal extends Vue {
  private taxObligationId: number | null = null;
  private amountLocal: number | string = "";
  private form: Partial<TaxObligationLedgerPayload> = {
    date: moment().format("YYYY-MM-DD"),
    balanceEffect: BalanceEffect.INCREASE,
    transactionType: TransactionType.PENALTY_ASSESSMENT
  };

  get balanceEffectOptions() {
    return Object.values(BalanceEffect).map(val => 
      SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build()
    );
  }

  get transactionTypeOptions() {
    const forbiddenTypes = [TransactionType.LIABILITY, TransactionType.OBLIGATION_PAYMENT, TransactionType.PENALTY_PAYMENT];
    return Object.values(TransactionType)
      .filter(val => !forbiddenTypes.includes(val))
      .map(val => 
        SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build()
      );
  }

  beforeOpen(event: any) {
    this.taxObligationId = event.params.taxObligationId;
    this.amountLocal = "";
    this.form = {
      date: moment().format("YYYY-MM-DD"),
      balanceEffect: BalanceEffect.INCREASE,
      transactionType: TransactionType.PENALTY_ASSESSMENT
    };
    this.$validator.reset();
  }

  closeModal() {
    this.$modal.hide("add-ledger-record-modal");
  }

  onTransactionTypeChange(val: TransactionType) {
    if (val === TransactionType.ADJUSTMENT) {
      return;
    }

    const increaseTypes = [TransactionType.LIABILITY, TransactionType.PENALTY_ASSESSMENT, TransactionType.INTEREST];
    const decreaseTypes = [TransactionType.CREDIT];

    if (increaseTypes.includes(val)) {
      this.form.balanceEffect = BalanceEffect.INCREASE;
    } else if (decreaseTypes.includes(val)) {
      this.form.balanceEffect = BalanceEffect.DECREASE;
    }
  }

  get isValid(): boolean {
    return !!(this.form.date && this.amountLocal && this.form.balanceEffect && this.form.transactionType);
  }

  async submit() {
    const valid = await this.$validator.validateAll();
    if (!valid || !this.taxObligationId) return;

    const payload: TaxObligationLedgerPayload = {
      date: this.form.date!,
      amountCents: Math.round(parseFloat(this.amountLocal.toString()) * 100),
      balanceEffect: this.form.balanceEffect!,
      transactionType: this.form.transactionType!
    };

    Application.startLoading();
    TaxObligationService.addLedgerRecord(this.taxObligationId, payload).then(
      () => {
        Application.stopLoading();
        this.$emit("added");
        this.closeModal();
      },
      err => {
        Application.stopLoading();
        processError(err, this);
      }
    );
  }
}
